import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import * as S from './AppContainer.styles';
import { darkTheme, lightTheme } from '../../../settings/appStyle/theme';
import { GlobalStyles } from '../../../settings/appStyle/global.style';
import { ThemeToggle } from '../../../components/uielements/themeToggle/themeToggle';

import { MainContent } from '../mainContent/MainContent';
import LeftSidebar from '../sidebarLeft/LeftSidebar';

export default function AppContainer() {
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [sessionKey, setSessionKey] = useState(0);

  const handleNewChat = () => {
    setSessionKey((k) => k + 1);
  };

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      <GlobalStyles />
      <S.AppWrapper>
        <ThemeToggle isDark={isDark} toggleTheme={toggleTheme} />
        <S.ContentWrapper>
          <LeftSidebar
            isOpen={isMobileMenuOpen}
            onClose={closeMobileMenu}
            onNewChat={handleNewChat}
            themeMode={isDark ? 'dark' : 'light'}
          />
          <MainContent onMenuClick={toggleMobileMenu} key={sessionKey} />
        </S.ContentWrapper>
      </S.AppWrapper>
    </ThemeProvider>
  );
}
